import Vue from 'vue';
import { get, sync } from 'vuex-pathify';
import { mapState, mapActions, mapMutations } from 'vuex';
export type VCalendarType = 'month' | 'year' | 'week' | 'day';

export default Vue.extend({
  name: 'vcalendar-callable',
  computed: {
    ...mapState({
      vfocus: (state: any) => state.vcalendar.focus,
      vtype: (state: any): VCalendarType => state.vcalendar.type
    }),
    focus: {
      get() {
        return this.vfocus;
      },
      set(v: string) {
        this.setFocus(v);
      }
    },
    type: {
      get() {
        return this.vtype;
      },
      set(v: string) {
        this.setType(v);
      }
    },
    today: get('vcalendar/today'),
    now: get('vcalendar/now')
  },
  methods: {
    ...mapMutations('vcalendar', ['setFocus', 'setType']),
    ...mapActions('calendar', {
      createCalendar: 'createCalendar'
    })
  }
});
